import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Dashboard } from './app/pages/dashboard/dashboard';
import { Documentation } from './app/pages/documentation/documentation';
import { Landing } from './app/pages/landing/landing';
import { Notfound } from './app/pages/notfound/notfound';
import { AuthGuardService } from '@shared/core/auth-guard.service';
import { MyTasksComponent } from './app/pages/my-tasks/my-tasks.component';
import { AIAgentComponent } from './app/pages/aiagent/aiagent.component';
import { AttributeEditorsComponent } from './app/pages/attribute-editors/attribute-editors.component';
import { WorkflowStagesComponent } from './app/pages/workflow-stages/workflow-stages.component';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        children: [
            { path: '', 
                component: Dashboard ,
                canActivate: [AuthGuardService]
            },
            { path: 'dashboard', component: Dashboard, canActivate: [AuthGuardService] },
            { path: 'mytasks', component: MyTasksComponent, canActivate: [AuthGuardService] },
            { path: 'attributeeditors', component: AttributeEditorsComponent, canActivate: [AuthGuardService] },
            { path: 'workflowstages', component: WorkflowStagesComponent, canActivate: [AuthGuardService] },
            { path: 'aiagent', component: AIAgentComponent, canActivate: [AuthGuardService] },
            { path: 'uikit', loadChildren: () => import('./app/pages/uikit/uikit.routes') },
            { path: 'purchasing', loadChildren: () => import('./app/modules/purchasing/purchasing.module').then(m => m.PurchasingModule) },
            { path: 'inventory', loadChildren: () => import('./app/modules/inventory/inventory.module').then(m => m.InventoryModule) },
            { path: 'housekeeping', loadChildren: () => import('./app/modules/housekeeping/housekeeping.module').then(m => m.HousekeepingModule) },
            { path: 'account', loadChildren: () => import('./app/modules/account/account.module').then(m => m.AccountModule) },
            { path: 'sales', loadChildren: () => import('./app/modules/sales/sales.module').then(m => m.SalesModule) },
            { path: 'shipping', loadChildren: () => import('./app/modules/shipping/shipping.module').then(m => m.ShippingModule) },
            { path: 'intergrations', loadChildren: () => import('./app/modules/intergration/intergration.module').then(m => m.IntergrationModule) },
            { path: 'market-analysis', loadChildren: () => import('./app/modules/market-analysis/market-analysis.module').then(m => m.MarketAnalysisModule) },
            { path: 'documentation', component: Documentation },
            { path: 'integration-dashboard', loadChildren: () => import('./app/modules/integration-v3/integration-v3.module').then(m => m.IntegrationV3Module) },
           //  { path: 'integration-dashboard2', loadChildren: () => import('./app/modules/integration-v2/integration-v2.module').then(m => m.IntegrationV2Module) },
            { path: 'pages', loadChildren: () => import('./app/pages/pages.routes') }
        ]
    },
    { path: 'landing', component: Landing },
    { path: 'notfound', component: Notfound },
    { path: 'auth', loadChildren: () => import('./app/modules/auth/auth.module').then(m => m.AuthModule) },//=> import('./modules/auth/auth.module').then(m => m.AuthModule)
    { path: '**', redirectTo: '/notfound' }
];
